import SkillEditorAction from './SkillEditor.action';

const { SkillEditorActionConstants } = SkillEditorAction;

const initalState = {
  user_other_skills: [],
  validation_error: {
    message: ''
  }
};

const SkillEditorReducer = (state = initalState, action) => {
  const { type = null, payload = null } = action;

  switch (type) {
    case SkillEditorActionConstants.SET_USER_OTHER_SKILLS: {
      if (payload !== null) {
        return { ...state, user_other_skills: [...payload] };
      }
      return state;
    }

    case SkillEditorActionConstants.SET_VALIDATION_ERROR: {
      if (payload !== null) {
        return { ...state, validation_error: { ...payload } };
      }
      return state;
    }
    default:
      return state;
  }
};

export default SkillEditorReducer;
